<template>
  <step-container heading="Follow Up Sequences">
    <template v-slot:description>
      <p>Below are a few sequences that we've created to get you started. You can have them preinstalled in your account
        and edit them to your liking.</p>
    </template>

    <div class="mt-200">
      <step-item-sequence
        v-for="sequence in sharedFollowUpSequences"
        :key="sequence.id"
        :sequence="sequence"
      />
    </div>
  </step-container>
</template>

<script>
import {defineComponent} from 'vue'
import StepContainer from "../component/StepContainer.vue";
import api from "../../../api";
import {MODELS} from "../../../services/models";
import StoreAssetGrid from "../../store/components/StoreAssetGrid.vue";
import StepItemSequence from "../component/StepItemSequence.vue";

export default defineComponent({
  name: "OnboardingStepFollowUpSequences",
  components: {StepItemSequence, StoreAssetGrid, StepContainer},
  data() {
    return {
      sharedFollowUpSequences: []
    }
  },
  created() {
    api.shareableGroups.sharedAssets().then((response) => {
      const forefrontAssets = response.data.filter((shareable) => shareable.shared_by_forefront)
      const sequences = forefrontAssets.filter(sharedAsset => {
        return sharedAsset.class_name === MODELS.FollowUpSequenceTemplate.class_name
      });

      this.sharedFollowUpSequences = sequences.map(sequence => {
        return {
          ...sequence,
          include: false
        }
      })
    });
  },
})
</script>

<style scoped lang="scss">

</style>
